<div
    class="mlp-blog-post-header -mlp-py"
    *ngIf="blogPost"
    [ngStyle]="{
        'background-image':
            blogPost.header_image != false
                ? 'url(' + blogPost.header_image + ')'
                : ''
    }"
></div>

<div class="container" *ngIf="blogPost">
    <div class="row">
        <section class="col-12 col-md-9 my-3">
            <div *ngIf="blogService.loading">
                <mlp-card>
                    <mlp-loading></mlp-loading>
                </mlp-card>
            </div>

            <article
                *ngIf="!blogService.loading"
                [attr.itemprop]="'Blog'"
                [attr.itemscope]
                [attr.itemtype]="'http://schema.org/BlogPosting'"
            >
                <p>
                    <mlp-blog-tags
                        [blog]="blogPost"
                        maxCategories="3"
                    ></mlp-blog-tags>
                </p>

                <h1 class="sg-heading__h2 mb-2">
                    {{
                        blogPost.title.rendered
                            ? blogPost.title.rendered
                            : blogPost.title
                    }}
                </h1>

                <div class="sg-divider__short mb-4"></div>

                <p class="post__date">
                    <span
                        [attr.itemprop]="'datePublished'"
                        attr.content="{{
                            blogPost.date | date: 'yyyy-MM-ddT13:08:00'
                        }}"
                        >{{
                            blogPost.date | momentTimezone: "d MMMM yyyy"
                        }}</span
                    >
                    <span *ngIf="blogPostAuthor"
                        >&#8226; By - {{ blogPostAuthor.name }}</span
                    >
                </p>

                <mlp-blog-post-body
                    [bodyContent]="blogPost.content.rendered"
                    [attr.itemprop]="'articleBody'"
                ></mlp-blog-post-body>
            </article>
        </section>

        <section class="col-12 col-md-3 my-3">
            <p class="sg-heading__h3">POPULAR POSTS</p>

            <mlp-card
                class="mb-3 d-block"
                [blog]="blog"
                [link]="['/blog', blog.slug]"
                cardStyle="lightFont"
                *ngFor="let blog of blogService.blogsPopular"
            >
                <mlp-blog-tags [blog]="blog" maxCategories="3"></mlp-blog-tags>
            </mlp-card>
        </section>
    </div>
</div>

<mlp-not-found *ngIf="notFound"></mlp-not-found>
